/**
 * The feed register: every source the platform can be given, what it is for,
 * and the shape it expects. A feed with no data is not an error — the boards
 * read `state` and say "awaiting feed" rather than drawing a zero.
 *
 * GENERATED by scripts/extract-feeds.mjs from .demo-src/original.js. It stitches
 * the FEEDS literal together with the Object.assign blocks that extend it, so
 * keys added after the declaration (notam among them) are present.
 */
// @ts-nocheck
/* eslint-disable */

export const FEEDS: any = Object.assign(
  {
    traffic:{label:"Air traffic volume", src:"AODB or ATC movement log", state:"waiting",
      shape:"{ arrivals, departures, hourly:[{h,arr,dep}], peak_hour, capacity_per_hour }"},
    stands: {label:"Stand availability", src:"Stand allocation system", state:"waiting",
      shape:"{ occupied:[standName], out_of_service:[standName] }"},
    crowd:  {label:"Terminal crowding", src:"People counting or queue measurement", state:"waiting",
      shape:"{ zones:[{id, name, occupancy, capacity, queue_min}] }"},
    weather:{label:"Weather", src:"AWOS or METAR", state:"waiting",
      shape:"{ observed, wind_dir, wind_kt, gust_kt, temp_c, feels_like_c, dewpoint_c, rh_pct, qnh, "
        + "vis_m, ceiling_ft, clouds:[{amount:'FEW'|'SCT'|'BKN'|'OVC', base_ft, type}], wx:[], "
        + "storms:[{type, bearing, distance_km, intensity, moving_to}], trend }"},
    fod:    {label:"FOD condition", src:"Inspection records (held here) + sweeper log", state:"partial",
      shape:"{ last_sweep, sweeps_today, sweeps_target, runway_checks_today, runway_checks_target, "
        + "collected_items_30d, damage_events_12m }"},
    experience:{label:"Passenger experience", src:"Terminal surveys and complaints register",
      state:"waiting",
      shape:"{ csat, csat_monthly:[{month, score}], cleanliness_score, washroom_score, "
        + "complaints_30d, complaints_resolved_pct, complaints:[{cat, count}], first_bag_min, "
        + "accessibility:{prm_requests_30d, assistance_on_time_pct, assistance_wait_min} }"},
    resilience:{label:"Operational resilience", src:"Continuity, crisis and exercise records",
      state:"waiting",
      shape:"{ exercises:[{type:'full'|'partial'|'tabletop', date, scope, outcome}], "
        + "bcp:{plans_total, plans_current, tested_pct, rto_met_pct, single_points_of_failure:[]}, "
        + "ups:{units, healthy}, comms:{paths, paths_up, tested}, "
        + "eoc:{ready, team_trained_pct, last_exercise}, notification_tested }"},
    sms:    {label:"Safety management system", src:"SMS / safety office", state:"waiting",
      shape:"{ reports_30d, target_report_rate, hazards_open, hazards_target, "
        + "assessments_current_pct, training_current_pct }"},
    audits: {label:"Audits and findings", src:"Quality and compliance office", state:"waiting",
      shape:"{ audits:[{ref, body, type, date, findings, closed}], "
        + "findings:[{id, title, body, level:'major'|'moderate'|'minor', raised, due, status}] }"},
    environment:{label:"Environmental compliance", src:"Environment office", state:"waiting",
      shape:"{ noise_complaints_30d, noise_target, spills_30d, waste_diverted_pct, "
        + "water_tests_pass_pct, wildlife_strikes_12m, wildlife_target }"},
    repair_costs:{label:"Repair cost rates", src:"Finance and maintenance contracts", state:"waiting",
      shape:"{ currency, labour_rate, classes:{ <class key>:{parts, hours, downtime, note} } }"},
    sustainability:{label:"Sustainability and future readiness",
      src:"Environment office and planning team", state:"waiting",
      shape:"{ emissions:{scope1_t, scope2_t, scope3_t, reduction_pct, aca_level, "
        + "target_monthly_t, monthly:[{month, scope1, scope2, scope3}]}, "
        + "energy:{total_kwh, intensity_kwh_m2, renewable_pct, peak_mw, monthly:[]}, "
        + "waste:{total_t, diverted_pct, hazardous_manifested_pct, streams:[{k, t}]}, "
        + "water:{total_m3, recycled_pct}, "
        + "noise:{events_above_threshold_30d, complaints_30d, night_movements_pct, "
        + "monitors_total, monitors_working, monthly:[{month, events, complaints}]}, "
        + "gse_electric_pct, fegp_use_pct, "
        + "future:{declared_annual_pax, master_plan_year, demand:[{year, pax}]} }"},
    stakeholders:{label:"Stakeholder performance", src:"Partners, contracts and coordination records",
      state:"waiting",
      shape:"{ airline_csat, slot_adherence_pct, "
        + "handling:{otp_pct, turnaround_met_pct, damage_events_90d, gse_serviceable_pct}, "
        + "security:{screening_pass_pct, posts_staffed_pct, certified_pct}, "
        + "maintenance:{sla_met_pct, mttr_h, ppm_completion_pct}, "
        + "government:{agencies:[{name, meetings_attended, meetings_held, response_h, "
        + "joint_exercises}]}, "
        + "parties:[{id, name, type, sla_pct, incidents_30d, contract_expiry, insurance_valid, "
        + "safety_reports}], monthly_sla:[{month, handling, security, maintenance}] }"},
    inventory:{label:"Stores and stock", src:"Stores and inventory system", state:"waiting",
      shape:"{ currency, fill_rate_pct, count_accuracy_pct, "
        + "items:[{sku, name, cat, uom, on_hand, min, max, on_order, unit_cost, lead_days, "
        + "consumed_30d, consumed_90d, consumed_365d, critical, location}], "
        + "monthly:[{month, issued, received}] }"},
    finance:{label:"Financial performance", src:"Finance system", state:"waiting",
      shape:"{ period, currency, aeronautical:{actual, budget}, "
        + "commercial:{actual, budget, retail, parking, concessions, advertising}, "
        + "opex:{actual, budget, categories:[{k, actual, budget}]}, "
        + "capex:{projects:[{id, name, budget, spent, pct_complete, forecast, status}]}, "
        + "monthly:[{month, rev, cost, budget}] }"},
    revenue:{label:"Revenue against target", src:"Finance system", state:"waiting",
      shape:"{ period, actual, target, aeronautical, non_aeronautical, currency }"},
    cctv:   {label:"CCTV surveillance", src:"Video management system", state:"waiting",
      shape:"{ cameras:[{id, zone, status:'online'|'offline'|'degraded', recording, last_seen}], "
        + "zones:[{name, total, online, critical}], recording_pct, retention_days, "
        + "retention_required_days, nvr:[{id, status, storage_pct}], blind_spots }"},
    access: {label:"Access control", src:"Access control system", state:"waiting",
      shape:"{ breaches:[{at, door, zone, type, resolved}], held_open_24h, tailgating_24h, "
        + "forced_24h, passes:{active, expired, lost}, readers:{total, faulty} }"},
    cyber:  {label:"Cyber security posture", src:"IT and OT security team", state:"waiting",
      shape:"{ as_at, threat_level, incidents_open:[{title, severity, at}], "
        + "vulnerabilities:{critical, high}, systems_patched_pct, mfa_pct, phishing_fail_pct, "
        + "backups:{last, verified}, ot_segmentation }"},
    incursion:{label:"Runway incursions", src:"Safety office / occurrence reporting", state:"waiting",
      shape:"{ events:[{at, severity:'A'|'B'|'C'|'D', category, location, note}], "
        + "hotspots:[{id, name}], stop_bars:{total, available}, "
        + "driver_permits_current, driver_permits_total }"}
  },
  {
    airside:{label:"Airside daily inspections", src:"Inspection records (held here) + airside ops log",
      state:"partial",
      shape:"{ patrols:[{slot:'dawn'|'day'|'dusk', started, completed, by, coverage_pct, findings}] }"},
    disrupt:{label:"Regional disruption", src:"NOTAM, airspace status and regional METAR/TAF", state:"waiting",
      shape:"{ airports:[{icao,name,status,reason,delay_min}], airspace:[{area,status,from,to,reason}], diversions_expected }"},
    pbb:    {label:"Passenger boarding bridges", src:"PBB control system / stand equipment log",
      state:"partial",
      shape:"{ target_dock_s, units:[{id, stand, status:'in_service'|'out_of_service'|'maintenance', "
        + "faults_24h, avg_dock_s, uptime_24h_pct, since, reason}] }"},
    notam:  {label:"NOTAM", src:"AIS / NOTAM office", state:"partial",
      shape:"{ items:[{id, subject, text, status:'active'|'planned', from, to, affects, closure}] }"},
    notam:  {label:"NOTAM", src:"AIS / NOTAM office", state:"partial",
      shape:"{ items:[{id, series, from, to, subject, scope, text, wo}] } — from and to as ISO "
        + "timestamps; a NOTAM with no 'to' is treated as permanent"},
    security:{label:"Security and threats", src:"Airport security forces / AVSEC control room",
      state:"partial",
      shape:"{ level:'normal'|'heightened'|'threat', threats:[{id, type, location, reported, by, "
        + "status:'active'|'contained'|'cleared', note}], last_update, updated_by }"},
    capacity:{label:"Declared capacity", src:"Aerodrome manual / slot coordination", state:"waiting",
      shape:"{ declared_movements_hour, annual_pax_capacity, terminal_design_pax_hour, stands_total }"},
    pax:    {label:"Passengers", src:"AODB / passenger reconciliation", state:"waiting",
      shape:"{ ytd, ytd_last_year, today, monthly:[{month:'2026-01', pax}] }"},
    paxflow:{label:"Terminal passenger flow", src:"People counting / AODB passenger numbers",
      state:"waiting",
      shape:"{ stages:[{id, name, in_pph, out_pph, capacity_pph, dwell_min}], journey_min, "
        + "target_journey_min, pax_in_terminal }"},
    airspace:{label:"Airspace status", src:"ATC / AIS / flow management", state:"partial",
      shape:"{ status:'normal'|'restricted'|'closed', atfm_delay_min, restrictions:[{area, type:"
        + "'restricted'|'danger'|'prohibited'|'temporary', from, to, reason}], procedures:[{name, "
        + "type:'ILS'|'RNP'|'VOR'|'visual', runway, status:'available'|'unavailable', reason}] }"},
    emergency:{label:"Emergency response", src:"Aerodrome emergency plan / watch room",
      state:"partial",
      shape:"{ level, event:{type, callsign, souls, location, at}, "
        + "agencies:[{name, state, eta_min}] } — or declare it here, which is the record either way"},
    vip:    {label:"VIP and royal movements", src:"Protocol office / movement schedule",
      state:"waiting",
      shape:"{ movements:[{callsign, type, category:'royal'|'state'|'vip'|'medical', "
        + "scheduled:true|false, eta, etd, stand, escort, notes}] }"},
    rff:    {label:"Rescue and fire fighting", src:"RFF watch room / fire service log", state:"partial",
      shape:"{ category_declared, category_available, response_time_s, target_response_s, "
        + "crew_on_duty, crew_required, last_drill, vehicles:[{id, type, status:'available'|"
        + "'unserviceable'|'maintenance', water_l, foam_l, water_cap_l, foam_cap_l}] }"},
    groundops:{label:"Ground operations status", src:"Airside operations / apron control",
      state:"partial",
      shape:"{ movement_area:[{id, name, status:'open'|'restricted'|'closed', reason}], "
        + "airside_vehicles, permits_valid, escorts_active, apron_incidents_24h, sweeps_today }"},
    turnaround:{label:"Aircraft turnaround", src:"Turnaround milestones / A-CDM", state:"partial",
      shape:"{ target_on_block_to_doors_min, target_disembark_min, target_turn_min, "
        + "turns:[{flight, stand, on_block, doors_open, last_pax_off, off_block, pax}] }"},
    docking:{label:"Docking guidance systems", src:"A-VDGS / stand equipment", state:"partial",
      shape:"{ units:[{id, stand, type, status:'in_service'|'fault'|'maintenance', "
        + "avg_dock_s, aborts_24h, last_calibration}] }"},
    handling:{label:"Ground handling performance", src:"Handling agent reporting / turnaround system",
      state:"partial",
      shape:"{ turnarounds, on_time_pct, avg_turn_min, target_turn_min, gse_available, gse_total, "
        + "incidents_24h, providers:[{name, flights, on_time_pct, avg_turn_min}] }"},
    cargo:  {label:"Cargo movement and storage", src:"Cargo terminal system / warehouse management",
      state:"partial",
      shape:"{ tonnes_today, target_tonnes_day, import_t, export_t, transit_t, dwell_hours, "
        + "target_dwell_hours, ulds_available, warehouse:[{id, name, type:'general'|'cold'|'dg'|"
        + "'valuable', capacity_t, used_t}] }"},
    immigration:{label:"Immigration", src:"Immigration authority / queue measurement", state:"partial",
      shape:"{ target_wait_min, wait_min, people_waiting, processed_pph, design_pph, "
        + "desks:[{id, name, open}], egates:{total, available} }"},
    customs:{label:"Customs and border", src:"Customs / border control", state:"partial",
      shape:"{ target_clearance_min, avg_clearance_min, referral_rate_pct, holds_open, "
        + "channels:[{id, name, type:'green'|'red'|'blue', open}], scanners:{total, available} }"},
    queues: {label:"Queues and crowds", src:"People counting / queue measurement", state:"partial",
      shape:"{ target_wait_min, pax_in_terminal, points:[{id, name, people, wait_min, "
        + "rate_in_ppm, rate_out_ppm, as_at}] }"},
    kerb:   {label:"Kerbside and airport entrances", src:"Traffic counting / ANPR / car park system",
      state:"partial",
      shape:"{ kerbs:[{id, name, type:'departures'|'arrivals', occupancy_pct, dwell_min, "
        + "target_dwell_min, vehicles_ph, capacity_vph}], entrances:[{id, name, queue_min, "
        + "flow_vph, capacity_vph, status}], car_park_full_pct }"},
    gates:  {label:"Gate crowding", src:"Gate hold room counting / boarding system", state:"partial",
      shape:"{ rooms:[{id, gate, occupancy, capacity, seats, flight, etd, boarding:true|false}] }"},
    seating:{label:"Seating availability", src:"Seat inventory / people counting", state:"partial",
      shape:"{ areas:[{id, name, seats_installed, seats_occupied, seats_oos}] }"},
    temps:  {label:"Terminal temperature", src:"BMS / HVAC controls", state:"partial",
      shape:"{ band_c:2, zones:[{id, name, temp_c, setpoint_c, rh_pct, status}] }"},
    emech:  {label:"Lifts, escalators and travelators", src:"Vertical transport monitoring / OEM log",
      state:"partial",
      shape:"{ units:[{id, type:'lift'|'escalator'|'travelator', location, status:'in_service'|"
        + "'fault'|'maintenance', faults_24h, last_inspection, cert_expiry}] }"},
    tsa:    {label:"Checkpoint screening", src:"Queue measurement / screening authority",
      state:"partial",
      shape:"{ target_queue_min, design_pph_lane, lanes:[{id, name, open:true|false, queue_min, "
        + "throughput_pph, status:'in_service'|'fault'|'closed', staff}], secondary_rate_pct, "
        + "alarm_rate_pct }"},
    flights:{label:"Flight delays and cancellations", src:"AODB / airline operational data",
      state:"partial",
      shape:"{ movements, on_time_pct, delayed, cancelled, avg_delay_min, target_delay_min, "
        + "causes:[{cause, count, airport_attributable:true|false}], worst:[{flight, dest, delay_min, cause}] }"},
    bhs:    {label:"Baggage handling", src:"BHS SCADA / baggage reconciliation", state:"partial",
      shape:"{ target_delivery_min, on_time_pct, avg_delivery_min, jams_24h, mishandled_per_1000, "
        + "backlog_bags, lines:[{id, name, status, throughput_bph, capacity_bph}] }"}
  },
  {
    power:  {label:"Electrical supply", src:"Power monitoring / SCADA", state:"partial",
      shape:"{ utility:'normal'|'loss', nominal_hz, frequency_hz, nominal_hv_kv, hv_kv, "
        + "nominal_lv_v, lv_v, load_mw, capacity_mw, power_factor, thd_pct, "
        + "facilities:[{id, load_pct, voltage_v, status:'normal'|'alarm'|'off', alarms:[] }] }"},
    gensets:{label:"Standby generators", src:"Generator log / test records", state:"partial",
      shape:"{ units:[{id, serves, fuel_pct, last_test, changeover_s, hours, status}] }"}
  },
);

/** How the platform is handed data, exactly as the demo exposes it. */
export function airfieldFeed(name: string, payload: unknown, demo?: boolean): boolean {
  const f = FEEDS[name];
  if (!f) return false;
  f.data = payload;
  f.state = demo ? "demo" : "live";
  f.updated = new Date();
  return true;
}
